"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BitsyWorld {
    constructor() {
        this.palettes = {};
        this.tiles = {};
        this.sprites = {};
        this.items = {};
    }
}
exports.BitsyWorld = BitsyWorld;
class BitsyResourceBase {
    constructor() {
        this.id = "";
        this.name = "";
    }
}
exports.BitsyResourceBase = BitsyResourceBase;
class BitsyObjectBase extends BitsyResourceBase {
    constructor() {
        super(...arguments);
        this.graphic = [];
        this.palette = 1;
    }
}
exports.BitsyObjectBase = BitsyObjectBase;
class BitsyTile extends BitsyObjectBase {
    constructor() {
        super(...arguments);
        this.palette = 1;
        this.wall = false;
    }
}
exports.BitsyTile = BitsyTile;
class BitsySprite extends BitsyObjectBase {
    constructor() {
        super(...arguments);
        this.palette = 2;
        this.dialogueID = "";
    }
}
exports.BitsySprite = BitsySprite;
class BitsyItem extends BitsyObjectBase {
    constructor() {
        super(...arguments);
        this.palette = 2;
        this.dialogueID = "";
    }
}
exports.BitsyItem = BitsyItem;
class BitsyPalette extends BitsyResourceBase {
    constructor() {
        super();
        this.colors = [];
        this.colors = [];
    }
    get background() { return this.colors[0]; }
    get tile() { return this.colors[1]; }
    get sprite() { return this.colors[2]; }
}
exports.BitsyPalette = BitsyPalette;
class BitsyParser {
    constructor() {
        this.world = new BitsyWorld();
        this.lineCounter = 0;
        this.lines = [];
    }
    static parse(lines) {
        const parser = new BitsyParser();
        parser.parseLines(lines);
        return parser.world;
    }
    reset() {
        this.lineCounter = 0;
        this.lines = [];
        this.world = new BitsyWorld();
    }
    parseLines(lines) {
        this.reset();
        this.lines = lines;
        while (!this.done) {
            if (this.checkLine("PAL"))
                this.takePalette();
            else if (this.checkLine("TIL"))
                this.takeTile();
            else if (this.checkLine("SPR"))
                this.takeSprite();
            else if (this.checkLine("ITM"))
                this.takeItem();
            else {
                while (!this.checkBlank()) {
                    this.skipLine();
                }
                this.skipLine();
            }
        }
    }
    get done() {
        return this.lineCounter >= this.lines.length;
    }
    get currentLine() {
        return this.lines[this.lineCounter];
    }
    checkLine(check) {
        return !this.done && this.currentLine.startsWith(check);
    }
    checkBlank() {
        return this.done || this.currentLine.trim().length == 0;
    }
    takeLine() {
        const line = this.currentLine;
        this.lines[this.lineCounter] = "";
        this.lineCounter += 1;
        return line;
    }
    skipLine() {
        this.takeLine();
    }
    skipLineIf(check) {
        if (this.checkLine(check)) {
            this.takeLine();
            return true;
        }
        return false;
    }
    takeSplit(delimiter) {
        return this.takeLine().split(delimiter);
    }
    takeSplitOnce(delimiter) {
        const line = this.takeLine();
        const i = line.indexOf(delimiter);
        return [line.slice(0, i), line.slice(i + delimiter.length)];
    }
    takeColor() {
        const [r, g, b] = this.takeSplit(",");
        return (parseInt(r) << 0)
            | (parseInt(g) << 8)
            | (parseInt(b) << 16)
            | (255 << 24);
    }
    takeResourceID(resource) {
        resource.id = this.takeSplitOnce(" ")[1];
    }
    tryTakeResourceName(resource) {
        resource.name = this.checkLine("NAME") ? this.takeSplitOnce(" ")[1] : "";
    }
    tryTakeWall(tile) {
        if (this.checkLine("WAL")) {
            tile.wall = this.takeSplitOnce(" ")[1] == "true";
        }
    }
    tryTakeObjectPalette(object) {
        if (this.checkLine("COL")) {
            object.palette = parseInt(this.takeSplitOnce(" ")[1]);
        }
    }
    tryTakeObjectDialogueID(object) {
        if (this.checkLine("DLG")) {
            object.dialogueID = this.takeSplitOnce(" ")[1];
        }
    }
    takePalette() {
        const palette = new BitsyPalette();
        this.takeResourceID(palette);
        this.tryTakeResourceName(palette);
        while (!this.checkBlank()) {
            palette.colors.push(this.takeColor());
        }
        this.world.palettes[palette.id] = palette;
    }
    takeFrame() {
        const frame = new Array(64).fill(false);
        for (let i = 0; i < 8; ++i) {
            const line = this.takeLine();
            for (let j = 0; j < 8; ++j) {
                frame[i * 8 + j] = line.charAt(j) == "1";
            }
        }
        return frame;
    }
    takeObjectGraphic(object) {
        const graphic = [];
        do {
            graphic.push(this.takeFrame());
        } while (this.skipLineIf(">"));
        object.graphic = graphic;
    }
    takeTile() {
        const tile = new BitsyTile();
        this.takeResourceID(tile);
        this.takeObjectGraphic(tile);
        this.tryTakeResourceName(tile);
        this.tryTakeWall(tile);
        this.tryTakeObjectPalette(tile);
        this.world.tiles[tile.id] = tile;
    }
    takeSprite() {
        const sprite = new BitsySprite();
        this.takeResourceID(sprite);
        this.takeObjectGraphic(sprite);
        this.tryTakeResourceName(sprite);
        this.tryTakeObjectDialogueID(sprite);
        this.tryTakeObjectPalette(sprite);
        this.world.sprites[sprite.id] = sprite;
    }
    takeItem() {
        const item = new BitsyItem();
        this.takeResourceID(item);
        this.takeObjectGraphic(item);
        this.tryTakeResourceName(item);
        this.tryTakeObjectDialogueID(item);
        this.tryTakeObjectPalette(item);
        this.world.items[item.id] = item;
    }
}
exports.BitsyParser = BitsyParser;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bitsy/parser/dist/index.js
// module id = 233
// module chunks = 0